import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const Portfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Portfolio samples - Fresh Creative Designed Posts
  const portfolioItems = [
    // Immigration - New Designs
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/4385c6208aad4b38c58798d612af3ec3317ad4ca732032261d017f17d1ebcead.png', category: 'Immigration', title: 'Study Visa Application Open' },
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/06534824424712db3b42ce3c92079f93e60bcb9a13e384005442e93fe69c87c6.png', category: 'Immigration', title: 'Work Permit Announcement' },
    { url: 'https://images.unsplash.com/photo-1576243165717-ce0a37f0ac8b?w=600', category: 'Immigration', title: 'Visa Consultation Services' },
    
    // Restaurant - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/1caf01a8bafa00ceb701d8fce2551b44c68b7bf00f65c423cb1e2922e7e964a1.png', category: 'Restaurant', title: 'Weekend Special 20% Off' },
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/d76e8b2677816fb4a0b2223c9b907b16451ec9e909c86c3c7a5a1d7d8a483a64.png', category: 'Restaurant', title: 'New Menu Launch' },
    { url: 'https://images.unsplash.com/photo-1771508558305-11364b4069b6?w=600', category: 'Restaurant', title: 'Fine Dining Experience' },
    { url: 'https://images.unsplash.com/photo-1761095596755-99ba58997720?w=600', category: 'Restaurant', title: 'Chef Special Dish' },
    { url: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600', category: 'Restaurant', title: 'Food Festival Event' },
    
    // Real Estate - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/22fbd1856f6a4e6e4ebfc52851ca8be373d55ae525fd7d0a2e0473e5375b2532.png', category: 'Real Estate', title: 'Luxury Villa For Sale' },
    { url: 'https://images.unsplash.com/photo-1767950470198-c9cd97f8ed87?w=600', category: 'Real Estate', title: 'Modern Villa Showcase' },
    { url: 'https://images.unsplash.com/photo-1770163821346-b7f07e59c98b?w=600', category: 'Real Estate', title: 'Premium Estate Launch' },
    { url: 'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=600', category: 'Real Estate', title: 'Home Interior Design' },
    { url: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600', category: 'Real Estate', title: 'Virtual Property Tour' },
    
    // Travel Agency - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/600a146024ed191f6973eb998d4245d993f3ee0eabca564ae4015de856e6cd0b.png', category: 'Travel', title: 'Bali Adventure Package' },
    { url: 'https://images.unsplash.com/photo-1766910701111-9eee02328e95?w=600', category: 'Travel', title: 'Tropical Paradise Getaway' },
    { url: 'https://images.unsplash.com/photo-1758716768666-2692b302a5e7?w=600', category: 'Travel', title: 'Luxury Resort Booking' },
    { url: 'https://images.unsplash.com/photo-1559329007-40df8a9345d8?w=600', category: 'Travel', title: 'Adventure Tour Package' },
    { url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600', category: 'Travel', title: 'Beach Holiday Special' },
    
    // Car Dealers - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/27c1150efbd589c210c24059cd2cfeeae5c8c7e4d5e1db07f2fae74359349535.png', category: 'Automotive', title: 'Year-End Clearance 30% Off' },
    { url: 'https://images.unsplash.com/photo-1769084701644-2a67b97f2415?w=600', category: 'Automotive', title: 'Sports Car Showcase' },
    { url: 'https://images.unsplash.com/photo-1763165561886-a9391b2132c1?w=600', category: 'Automotive', title: 'Premium Vehicle Launch' },
    { url: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600', category: 'Automotive', title: 'New Model Arrival' },
    { url: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=600', category: 'Automotive', title: 'Limited Edition Launch' },
    
    // Fitness/Academy - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/60300d6d62e026ff0613dc717c194de8704763fb1cbf3da1e530a3a9df505a64.png', category: 'Fitness', title: 'New Year Membership 20% Off' },
    { url: 'https://images.unsplash.com/photo-1734668486909-4637ecd66408?w=600', category: 'Fitness', title: 'Fitness Challenge Post' },
    { url: 'https://images.unsplash.com/photo-1593234270323-0414ec1574e1?w=600', category: 'Fitness', title: 'Group Training Session' },
    { url: 'https://images.unsplash.com/photo-1703231528210-fb52f76133b0?w=600', category: 'Fitness', title: 'Personal Training Promo' },
    { url: 'https://images.unsplash.com/photo-1717500251805-cd0306a48de4?w=600', category: 'Fitness', title: 'Transformation Challenge' },
    
    // Education - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/0bd63edb594626e164c67e683596d1d07c03f8cef8b0166535f8a8411606cc8a.png', category: 'Education', title: 'JEE NEET Coaching Admission' },
    { url: 'https://images.unsplash.com/photo-1719159381916-062fa9f435a6?w=600', category: 'Education', title: 'New Batch Admission' },
    { url: 'https://images.unsplash.com/photo-1759922378146-8e143fb47cd4?w=600', category: 'Education', title: 'Workshop Announcement' },
    { url: 'https://images.unsplash.com/photo-1759922378123-a1f4f1e39bae?w=600', category: 'Education', title: 'Student Success Story' },
    { url: 'https://images.unsplash.com/photo-1563394867331-e687a36112fd?w=600', category: 'Education', title: 'Online Learning Program' },
    
    // Fashion/Retail - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/fc14428ad6f41c75e1e42064e91c802446db199d4c6ec4a2df3c5269275835e5.png', category: 'Retail', title: 'Flat 50% Off Sale' },
    { url: 'https://images.unsplash.com/photo-1769944508939-4cefc07d6511?w=600', category: 'Retail', title: 'New Collection Launch' },
    { url: 'https://images.unsplash.com/photo-1765009433753-c7462637d21f?w=600', category: 'Retail', title: 'Store Opening Event' },
    { url: 'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?w=600', category: 'Fashion', title: 'Fashion Week Special' },
    { url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600', category: 'Retail', title: 'Weekend Shopping Deal' },
    
    // Healthcare - Designed Posts
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/537a1485a4c7c360b2bd43b9841c30eaea28aeb7e146c9fe32f76421203f62bb.png', category: 'Healthcare', title: 'Free Health Checkup Camp' },
    { url: 'https://images.unsplash.com/photo-1556742111-a301076d9d18?w=600', category: 'Healthcare', title: 'Medical Checkup Offer' },
    { url: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600', category: 'Healthcare', title: 'Wellness Center Services' },
    
    // Business/Corporate
    { url: 'https://static.prod-images.emergentagent.com/jobs/2304d325-e856-415f-87c3-0487b81fdef4/images/886c583dd6d4d211814a61a7430660e2e544548528b0940e0590375bef219690.png', category: 'Business', title: 'Digital Marketing Workshop' },
    { url: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600', category: 'Business', title: 'Corporate Event Invitation' },
    { url: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600', category: 'Business', title: 'Professional Services Ad' },
    { url: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?w=600', category: 'Business', title: 'Business Growth Tips' },
    { url: 'https://images.unsplash.com/photo-1556742400-b5a5c6a4e1b2?w=600', category: 'Tech', title: 'Tech Startup Launch' },
  ];

  const categories = ['All', ...new Set(portfolioItems.map(item => item.category))];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredItems = activeCategory === 'All' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <div className="min-h-screen pt-32 pb-20 bg-white/5" data-testid="portfolio-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6 gradient-text" data-testid="portfolio-title">
            Creative Gallery
          </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed">
            Explore our portfolio of stunning social media designs across various industries
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              data-testid={`category-filter-${category.toLowerCase()}`}
              className={`px-6 py-2 rounded-full font-medium transition-all ${
                activeCategory === category
                  ? 'bg-gradient-to-r from-[#3B82F6] to-[#2563EB] text-white shadow-[0_0_20px_rgba(59,130,246,0.5)]'
                  : 'glass text-gray-300 hover:text-white hover:border-white/20'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <motion.div 
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
          layout
        >
          {filteredItems.map((item, index) => (
            <motion.div
              key={index}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.02 }}
              whileHover={{ y: -5 }}
              className="relative group cursor-pointer overflow-hidden rounded-xl"
              onClick={() => setSelectedImage(item)}
              data-testid={`portfolio-item-${index}`}
            >
              <img
                src={item.url}
                alt={item.title}
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <div>
                  <div className="text-xs text-[#3B82F6] mb-1">{item.category}</div>
                  <div className="text-sm font-semibold text-white">{item.title}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Lightbox */}
        <AnimatePresence>
          {selectedImage && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black/95 backdrop-blur-xl flex items-center justify-center p-4"
              onClick={() => setSelectedImage(null)}
              data-testid="lightbox"
            >
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-8 right-8 text-white hover:text-[#3B82F6] transition-colors"
                data-testid="lightbox-close-button"
              >
                <X size={32} />
              </button>
              <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.9 }}
                onClick={(e) => e.stopPropagation()}
                className="max-w-5xl w-full"
              >
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  className="w-full h-auto rounded-2xl"
                />
                <div className="mt-6 text-center">
                  <div className="text-[#3B82F6] text-sm mb-2">{selectedImage.category}</div>
                  <div className="text-white text-xl font-semibold">{selectedImage.title}</div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Portfolio;